import {ValueResolver} from '@/engine';
import {InvestorAccount} from '@/types/client-info';
import {mapAccountTypeToDomainValue} from '@/utils/client-info/mappers';

export const getAccountLabel = (account: InvestorAccount, domainValueResolver: ValueResolver): string => {
  const accountType = mapAccountTypeToDomainValue(account.plan);

  if (account.spousalFlag === 'Y' && accountType) {
    const spousalLabel = domainValueResolver({...accountType, property: 'spousalLabel'});
    if (spousalLabel) {
      return spousalLabel;
    }
  }

  return domainValueResolver(accountType ?? account.plan);
};
